<h1 mat-dialog-title class="aza-pa-dialog-title" translate>DEPENDENCIES</h1>

<div mat-dialog-content class="table-container aza-pa-dialog-content">
    <azavista-table
        *ngIf="advancedSearchData"
        [columns]="columns" [displayedColumns]="displayedColumns" [dataSource]="dataSource"
        [actions]="actions" [pagingOptions]="pagingOptions"
        [showAdvancedSearch]="true"
        [showAdvancedSearchQuickSearch]="true"
        [showAdvancedSearchFilters]="true"
        [advancedSearchAllFields]="advancedSearchData.allFields"
        [advancedSearchFilters]="advancedSearchData.advancedFilters"
        [selection]="selection"
        (rowActionSelected)="onRowActionSelected($event)"
        (advancedSearchChanged)="searchDependencies($event)"
        (rowClicked)="processViewOrEditAction($event.id)" (pagingChanged)="searchDependencies($event)">
    </azavista-table>
</div>

<div mat-dialog-actions class="aza-pa-action-buttons">
    <azavista-flat-button (click)="onAddNew()" color="primary" class="aza-pa-action-button-apply-buton">+ <span translate
            class="uppercased">ADD_DEPENDENCY</span></azavista-flat-button>
    <azavista-flat-button (click)="onClose()" color="primary" class="add-new-dependency-button-close-button"><span translate
            class="uppercased">CLOSE</span></azavista-flat-button>
</div>
